// extracted by mini-css-extract-plugin
export default {"form":"styles-scoped__form--txnOk","error":"styles-scoped__error--eYCUu","dates":"styles-scoped__dates--yxagw","actions":"styles-scoped__actions--Km0O1"};